itsoftApp.createModule("navInstruction", ["pageLoad", "windowScroll", "windowResize"], function () {
    const module = this;

    const NavInstruction = function () {
        this.list = document.querySelector('.js-nav-side');
        this.links = this.list && this.list.querySelectorAll('[data-href]');
        this.btnBackToTop = document.querySelector('.js-back-to-top');
        this.data = {
            class: {
                active: '_active',
            },
            breakpoint: 1023,
            names: [],
            blocks: [],
        }


        this.init();
    };

    /**
     * Получаем id блоков из ссылок
     */
    NavInstruction.prototype.getNames = function() {
        const NAV = this;

        for (const link of NAV.links) {
            NAV.data.names.push(link.dataset.href);
        }
    }

    /**
     * Находим блоки по их id
     */
    NavInstruction.prototype.setBlocks = function() {
        const NAV = this;

        for (const name of NAV.data.names) {
            NAV.data.blocks.push(document.querySelector(`#${name}`));
        }
    }

    /**
     * Получаем блок, который помещается в окно
     */
    NavInstruction.prototype.isBlockInWindow = function (el) {
        const { top, bottom } = el.getBoundingClientRect();
        const pointTop = (top - itsoftApp.utils.getHeaderHeight()).toFixed();
        const pointBottom = (bottom - itsoftApp.utils.getHeaderHeight()).toFixed();

        return pointTop < 3 && pointBottom > 3;
    }

    /**
     * Подсвечиваем активный блок
     */
    NavInstruction.prototype.setCurBlock = function() {
        const NAV = this;

        for (const link of NAV.links) {
            link.classList.remove(NAV.data.class.active);
        }

        for (let index = 0; index < NAV.data.blocks.length; index++) {
            const block = NAV.data.blocks[index];
            if (NAV.isBlockInWindow(block)) {
                NAV.links[index].classList.add(NAV.data.class.active);
                break;
            }
        }
    }

    /** Показываем/скрываем кнопку 'Наверх' */
    NavInstruction.prototype.checkBtnTop = function() {
        if (this.btnBackToTop && window.innerWidth <= this.data.breakpoint && window.scrollY > 100) {
            this.btnBackToTop.classList.add(this.data.class.active);
        } else {
            this.btnBackToTop.classList.remove(this.data.class.active);
        }
    }

    /**
     * Событие при скролле/ресайзе
     */
    NavInstruction.prototype.onScroll = function () {
        const NAV = this;

        NAV.setCurBlock();
        NAV.checkBtnTop();
    };

    /**
     * Инит
     */
    NavInstruction.prototype.init = function () {
        const NAV = this;

        if (NAV.list) {
            NAV.getNames();
            NAV.setBlocks();
            NAV.onScroll();

            itsoftApp.modules.pageLoad.addEvent(function () {
                itsoftApp.modules.windowResize.addEvent(NAV.onScroll.bind(NAV));
                itsoftApp.modules.windowScroll.addEvent(NAV.onScroll.bind(NAV));
            });
        }
    };

    new NavInstruction();
    module.callback = NavInstruction;
});
